import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { isWebComponentFlow } from '../../commonCode';

export const CustomLinearProgres = (props) => {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const baseContext = isWebComponentFlow();
  const { theme } = baseContext;
  const { progressVal, maxProgressVal, triggerLinearprogress } = props;
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [progressPercentageCalc, setProgressPercentageCalc] = useState(0);

  useEffect(() => {
    let progressPercent;
    if (progressVal) {
      progressPercent = (progressVal / maxProgressVal) * 100;
      setProgressPercentageCalc(progressPercent);
      setProgressPercentage(progressPercent <= 100 ? progressPercent : 100);
    } else {
      setProgressPercentageCalc(0);
      setProgressPercentage(0);
    }
  }, [progressVal, triggerLinearprogress, maxProgressVal]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ width: '100%' }}>
        <LinearProgress
          variant="determinate"
          value={progressPercentage}
          sx={{
            height: 7,
            borderRadius: '5px',
            backgroundColor: '#EAEAEA',
            '& .MuiLinearProgress-bar': {
              backgroundColor:
                progressPercentageCalc === 100
                  ? '#0B6C03'
                  : progressPercentageCalc > 100
                  ? theme?.palette?.danger?.main
                  : theme?.palette?.orientalPrimary?.main,
            },
          }}
        />
      </Box>
    </Box>
  );
};

CustomLinearProgres.propTypes = {
  progressVal: PropTypes.number.isRequired,
  maxProgressVal: PropTypes.number.isRequired,
  triggerLinearprogress: PropTypes.string,
};
